import { render } from "./switch-table-item.vue?vue&type=template&id=e5c8e76c&scoped=true&ts=true"
import script from "./switch-table-item.vue?vue&type=script&lang=ts"
export * from "./switch-table-item.vue?vue&type=script&lang=ts"

import "./switch-table-item.vue?vue&type=style&index=0&id=e5c8e76c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c8e76c"]])

export default __exports__